export default {
  'component.logger.label.endpoint': 'Конечная точка',
  'component.logger.label.token': 'Токен',
  'component.logger.label.applicationName': 'Имя приложения',
  'component.logger.label.source': 'Источник',
}
